import React from "react";

import { ModalBody, ModalFooter } from "../../../../../application/modal";
import { BtnType, Button } from "../../../../../modules/primitives";
import { useModelPopup } from "../../../../../common/hooks";

const LessonLearnedModal = ({ lessonsData, taskInstance }) => {
  const popup = useModelPopup();

  const handleClose = () => {
    popup.hide();
  };

  return (
    <div>
      <ModalBody>
        <div className="d-flex flex-column">
          {
            taskInstance ? (
              lessonsData.map(lesson => (
                <div className="d-flex flex-column mb-2" key={lesson.project_id}>
                  <span className="font-weight-bold mb-1">{lesson.name}</span>
                  <div>
                    {
                      lesson.lessons_learned_project_fields?.map(l => (
                        <div className="d-flex flex-column">
                          <span>{l.field_name}</span>
                          <p>{l.field_value || "-"}</p>
                        </div>
                      ))
                    }
                    <hr className="mb-2" />
                  </div>
                </div>
              ))
            ) : (
              lessonsData.map((lesson, index) => (
                <div className="d-flex flex-column mb-2" key={`${lesson.field_name}_${index}`}>
                  <span>{lesson.field_name}</span>
                  <p>{lesson.field_value || '-'}</p>
                </div>
              ))
            )
          }
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" btn={BtnType.REGULAR} onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </div>
  );
};
export default LessonLearnedModal;
